import React from 'react';
import { ReactComponent as BrandLogoFullIcon } from '../resources/brand/quantiply-logo-full.svg';
import { ReactComponent as BrandLogoIcon } from '../resources/brand/quantiply-logo.svg';
import { ReactComponent as BrandLogoWhiteIcon } from '../resources/brand/quantiply-logo-full-white.svg';

export const BrandLogoFull = (props) => <BrandLogoFullIcon {...props} />;
export const BrandLogo = (props) => <BrandLogoIcon {...props} />;
export const BrandLogoWhite = (props) => <BrandLogoWhiteIcon {...props} />;
